import axios from "axios";
import config from "src/config";
import getAuthHeader from "../headers/get-auth-header";
import getJsonContentHeader from "../headers/get-json-content-header";
import { ISavedUserColumn } from "./interfaces";

async function saveUserColumns(
  accessToken: string,
  organisationId: string,
  payload: ISavedUserColumn[]
): Promise<void> {
  const options = {
    headers: { ...getAuthHeader(accessToken), ...getJsonContentHeader() },
  };

  return axios.post(
    `${config.projectManagementService.url}/user/save-projects-columns?orgId=${organisationId}`,
    payload,
    options
  );
}

export default saveUserColumns;
